import { useEffect } from "react"

import { datadogRum } from "@datadog/browser-rum"
import { ErrorBoundary } from "@datadog/browser-rum-react"
import dayjs from "dayjs"
import PropTypes from "prop-types"
import { Provider } from "react-redux"
import { HistoryRouter as Router } from "redux-first-history/rr6"
import { PersistGate } from "redux-persist/integration/react"

import { ErrorFallback } from "./Components/ErrorFallback"
import ScrollToTop from "./Components/ScrollToTop"
import InitComponent from "./Containers/InitComponent"

import "dayjs/locale/de" // important!

import { GoogleOAuthProvider } from "@react-oauth/google"

import "dayjs/locale/en-gb"
import "dayjs/locale/es"
import "dayjs/locale/fr"
import "dayjs/locale/it"
import "dayjs/locale/nl"
import "dayjs/locale/pt"
import "dayjs/locale/ru"
import "dayjs/locale/zh-cn"

import localeData from "dayjs/plugin/localeData"
import updateLocale from "dayjs/plugin/updateLocale"

import "./App.less"
import "./Components/Forms/Form.less"
import "./Containers/LoginPage/styles.less"
import "./index.less"
import "./video.less"

dayjs.extend(localeData)
dayjs.extend(updateLocale)

dayjs.updateLocale("en-gb", {
  weekdaysMin: ["S", "M", "T", "W", "T", "F", "S"],
  monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
})

document.addEventListener("visibilitychange", () => {
  if (!document.visible) {
    document.activeElement.blur()
  }
})

const handleScroll = function (e) {
  let global = document.getElementById("global-wrap")
  if (global?.style.overflow === "hidden") {
    document.body.style.overflow = "hidden"
  } else {
    document.body.style.overflow = "unset"
  }
}

document.addEventListener("scroll", handleScroll, false)
document.addEventListener("wheel", handleScroll, { passive: false })

function App({ store }) {
  useEffect(() => {
    const unsubscribe = store.history.listen(({ location }) => {
      datadogRum.startView(location.pathname)
    })

    return () => unsubscribe()
  }, [store.history])

  return (
    <ErrorBoundary fallback={ErrorFallback}>
      <Provider store={store.store}>
        <PersistGate loading={null} persistor={store.persistor}>
          <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <Router history={store.history}>
              <ScrollToTop />
              <InitComponent />
            </Router>
          </GoogleOAuthProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  )
}

App.propTypes = {
  store: PropTypes.shape({
    store: PropTypes.object,
    persistor: PropTypes.object
  }).isRequired
}

export default App
